export default [
  'boss',
  'admin',
  'pm',
  'wasa',
]